const LOCAL_HOST = "127.0.0.1"; // Mac
//const LOCAL_HOST = '192.168.1.86' //Julien
// const LOCAL_HOST = '192.168.1.23' // Paul
// const LOCAL_HOST= '192.168.1.103' // Elvan

export const Config = {
  API_URL: "https://europe-west3-gopopme-7353a.cloudfunctions.net/api",
  API_URL_DEV: `http://${LOCAL_HOST}:5001/gopopme-7353a/europe-west3/api`,
  GAME_SERVER_HOST_OVERRIDE: null, // LOCAL_HOST || null
  REALTIME_DATABASE_URL:
    "https://gopopme-7353a-default-rtdb.europe-west1.firebasedatabase.app",
  FILESTACK_API_KEY: "AUCXa0n1QqGFG9Ukmkp09z",
};
